import { PatientsAPI, CouplePatientAPI, GroupPatientAPI, listAllTherapistPatients } from "../../patient";

/**
 * The patients, couples and groups a session is held with, read from the
 * patient module for the session screens that pick or name them.
 */

export async function getPatient(id: string) {
    const { data } = await PatientsAPI.get(id);
    return data;
}

export async function getCouplePatient(id: string) {
    const { data } = await CouplePatientAPI.get(id);
    return data;
}

export async function getGroupPatient(id: string) {
    const { data } = await GroupPatientAPI.get(id);
    return data;
}

/** Every patient of the therapist: a session can be held with any of them. */
export async function listTherapistPatients(therapistId: string) {
    return listAllTherapistPatients(therapistId);
}

export async function listTherapistCouplePatients(therapistId: string) {
    const { data } = await CouplePatientAPI.listByTherapist(therapistId);
    return data;
}

export async function listGroupPatients() {
    const { data } = await GroupPatientAPI.list();
    return data;
}
